import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

import L from 'leaflet';

import './leaflet-ruler.css';
import './leaflet-ruler';

export function LeafletRuler() {
  const map = useMap();

  useEffect(() => {
    if (!map) {
      return;
    }

    (L.control as any).ruler().addTo(map);
  }, [map]);

  return null;
}
